import { Component, Input } from '@angular/core';
import { FilterModelDto } from '../../../../models/filter.model';

@Component({
  selector: 'app-recurring-page-filter',
  templateUrl: './recurring-page-filter.component.html',
  styleUrls: ['./recurring-page-filter.component.scss'],
})
export class RecurringPageFilterComponent {
  @Input() filterStatuses: FilterModelDto[] | undefined;
  @Input() filterCurrencies: FilterModelDto[] | undefined;
  @Input() filterRecPaymentPeriodTypes: FilterModelDto[] | undefined;
  @Input() filterNotifications: FilterModelDto[] | undefined;

  filterSumFrom: FilterModelDto = {
    fieldName: 'sum_from',
    value: '',
    description: '',
  };

  filterSumTo: FilterModelDto = {
    fieldName: 'sum_to',
    value: '',
    description: '',
  };

  filterStart: FilterModelDto = {
    fieldName: 'date_from',
    value: '',
    description: '',
  };

  filterEnd: FilterModelDto = {
    fieldName: 'date_to',
    value: '',
    description: '',
  };
}
